export const formatCurrency = (value, currency = "BRL", locale = "pt-BR") => {
  if (!value) {
    return "-";
  }

  if (typeof value !== "number") {
    value = parseFloat(value);
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(value);
};

export const formatBoolean = (value) => {
  if (value || value === "true") {
    return "SIM";
  }

  return "NÃO";
};

export const formatDate = (value, locale = "pt-BR") => {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  return new Intl.DateTimeFormat(locale).format(date);
};

export const formatDatetime = (value, locale = "pt-BR") => {
  if (!value) return "-";

  const date = new Date(value);

  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(date);
};
